import React, { createContext, useContext, useState } from 'react';
import type { PlanId } from '../data/plans';
type PlanContextValue = {
  selected: PlanId;
  setSelected: (id: PlanId) => void;
};
const PlanContext = createContext<PlanContextValue | null>(null);
export function PlanProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selected, setSelected] = useState<PlanId>('premium');
  return <PlanContext.Provider value={{
    selected,
    setSelected
  }} data-id="element-290" data-mp="znpp3faz52b4">{children}</PlanContext.Provider>;
}
export function usePlan() {
  const ctx = useContext(PlanContext);
  if (!ctx) throw new Error('usePlan must be used inside PlanProvider');
  return ctx;
}